export interface ICountryPhoneNumber{
  id          : string;
  iso         : string;
  name        : string;
  code        : string;
  flagImagePos: string;
}
